/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { superVoterAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type MultiRevoteProps = {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
  nftIds: Array<number>
  maxLock: boolean
}

export const revoteMultiple = async ({
  account,
  chainId,
  config,
  superVoterAddress,
  nftIds,
  maxLock,
}: MultiRevoteProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: superVoterAbi as Abi,
        account,
        address: superVoterAddress,
        args: [maxLock, nftIds],
        chainId,
        functionName: "revoteMultiple",
      },
    })
    return result
  } catch (error: any) {
    console.error("revoteMultiple", error)
    return { success: false, error: error.message, code: error.code }
  }
}
